if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.currentVariantFeaturedMediaId = this.getAttribute("data-current-variant-featured-media-id");
        this.initialIsBusty = this.getAttribute("data-initial-is-busty");
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.sliderComponent = this.querySelector("slider-component[data-pdp_model_image_data_src]");
        this.mql = window.matchMedia("(min-width: 750px)");
        if (this.elements.thumbnails !== null) {
          this.elements.thumbnails.querySelectorAll("[data-target]").forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener("click", this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
          this.elements.viewer.addEventListener("slideChanged", debounce(this.onSlideChanged.bind(this), 500));
        }

        if (this.dataset.desktopLayout.includes("thumbnail") && this.mql.matches) this.removeListSemantic();

        try {
          this.grouped_pictures = JSON.parse(
            document.getElementById("pdp_model_image_data").innerHTML.trim() || "[]"
          );

          let sliderComponent = this.querySelector("slider-component[data-pdp_model_image_data_src]");
          this.model_data_src =
            (sliderComponent && sliderComponent.getAttribute("data-pdp_model_image_data_src").trim()) || "";

          // check if each media item's alt tag includes the embedded model information.
          const altTagDelimiter = "@model_info:";
          let data_str = document.getElementById("pdp_media_data").innerHTML.trim();
          const decodedString = decodeURIComponent(data_str);

          //Populate "this.pdp_media_data" array with the "model info" parsed from the alt tags of each product media item.
          this.pdp_media_data = JSON.parse(decodedString || "{}");
          for (const [key, value] of Object.entries(this.pdp_media_data)) {
            let alt = value;
            if (alt.includes(altTagDelimiter)) {
              const start_idx = alt.indexOf(altTagDelimiter) + altTagDelimiter.length;
              const model_info_str = alt.substring(start_idx);
              this.pdp_media_data[key] = model_info_str;
            } else {
              this.pdp_media_data[key] = "";
            }
          }

          // only set active media if current variant is busty, otherwise use media order from Shopify product admin on initial load
          if (this.initialIsBusty && this.initialIsBusty === 'true') {
            this.setActiveMedia(`${this.dataset.section}-${this.currentVariantFeaturedMediaId}`, true);
          }
        } catch (e) {
          console.log(e);
        }
      }

      isBetween(val, a, b, inclusive) {
        const min = Math.min.apply(Math, [a, b]);
        const max = Math.max.apply(Math, [a, b]);
        return inclusive ? val >= min && val <= max : val > min && val < max;
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement?.dataset?.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      scrollToActiveMedia(mediaId) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        const header = document.querySelector("header");
        window.scrollTo(0, activeMedia.offsetTop - header.offsetHeight);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        this.activeMedia = activeMedia;
        this.elements.viewer.querySelectorAll("[data-media-id]").forEach((element) => {
          element.classList.remove("is-active");
        });
        activeMedia.classList.add("is-active");

        // stacked layout needs to move all the images in range
        if (this.dataset.desktopLayout === "stacked" && prepend) {
          this.grouped_pictures.forEach(group => {
            const range = group.split("-");
            const activeMediaIsInRange = this.isBetween(
              Number(activeMedia.dataset.mediaPosition),
              range[0],
              range[1],
              true
            );

            if (activeMediaIsInRange) {
              for (let i = Number(range[1]); i >= Number(range[0]); i--) {
                const nextActiveMedia = this.elements.viewer.querySelector(`[data-media-position="${i}"]`);
                nextActiveMedia && activeMedia.parentElement.prepend(nextActiveMedia);
              }
            }
          })
        } else if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        });
        this.playActiveMedia(activeMedia);

        if (this.elements.thumbnails !== null) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop / 2 });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(".product__modal-opener--image img");
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace("[index]", position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute("role", "presentation"));
      }
    }
  );
}
